module.exports = __webpack_public_path__ + "img/pic6.ba43b351.jpg";